import { render, staticRenderFns } from "./IntegrationsPanel.vue?vue&type=template&id=235d4322&scoped=true"
import script from "./IntegrationsPanel.vue?vue&type=script&lang=js"
export * from "./IntegrationsPanel.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsPanel.vue?vue&type=style&index=0&id=235d4322&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235d4322",
  null
  
)

export default component.exports